import React from "react";
import { PrimaryButton, GhostButton } from "../components/site/Buttons";
import { MaskedLines, Reveal } from "../components/site/Reveal";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center bg-ivory">
      <div className="yadid-container py-40 text-center flex flex-col items-center">
        <Reveal>
          <p className="eyebrow text-brass mb-8">404</p>
        </Reveal>
        <MaskedLines
          tag="h1"
          lines={["The path ends here."]}
          delay={0.2}
          className="font-serif text-ink text-4xl md:text-5xl lg:text-[3.9rem] tracking-[-0.02em]"
        />
        <Reveal delay={0.4}>
          <p className="mt-8 text-lg text-ink/60 font-light max-w-md mx-auto">
            The page you are looking for may have moved or no longer exists.
          </p>
        </Reveal>
        <Reveal delay={0.5}>
          <div className="mt-12 flex flex-col sm:flex-row items-center gap-4">
            <PrimaryButton to="/">Return Home</PrimaryButton>
            <GhostButton to="/contact">Start a Conversation</GhostButton>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
